import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'

export type JobTicketProps = ModelProps<JobTicket>

/**
 * A ticket for a job.
 */
export class JobTicket extends Model<JobTicket> {
  id = Id.none
  jobId = Id.none
  @observable accessor statusMessage = ''
  @observable accessor lastUpdated = unixEpoch()
}
